import { render, staticRenderFns } from "./DadosCronograma.vue?vue&type=template&id=8f35c18c"
import script from "./DadosCronograma.vue?vue&type=script&lang=js"
export * from "./DadosCronograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports